import type { IconData } from '@stacksjs/iconify-core'

export const keyholeLockCircle: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M24 3c11.598 0 21 9.402 21 21s-9.402 21-21 21S3 35.598 3 24S12.402 3 24 3\"/><path d=\"M27.505 25.194a6.6 6.6 0 1 0-7.008 0l-1.643 7.392c-.206.925.28 1.847 1.208 2.042c.913.192 2.225.372 3.938.372s3.026-.18 3.939-.372c.928-.195 1.414-1.117 1.208-2.042z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default keyholeLockCircle
